import {
  faFacebook,
  faInstagram,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

import {
  IconStyled,
  SocialNetworkContainer,
} from './SocialNetworksBancoValor.styles';

const Icon = ({ iconName, link, hasMarginRight }) => (
  <IconStyled
    href={link}
    target="_blank"
    rel="noopener"
    hasMarginRight={hasMarginRight}
  >
    <FontAwesomeIcon icon={iconName} />
  </IconStyled>
);

Icon.propTypes = {
  iconName: PropTypes.object.isRequired,
  link: PropTypes.string.isRequired,
  hasMarginRight: PropTypes.bool,
};

export const SocialNetworksBancoValor = () => (
  <SocialNetworkContainer>
    <Icon
      iconName={faFacebook}
      link="https://www.facebook.com/share/1RmnbUC5Vi/?mibextid=wwXIfr"
      hasMarginRight
    />
    <Icon
      iconName={faInstagram}
      link="https://www.instagram.com/distribuidoravalor.ao?igsh=MXY3OXlsdW14MG16dw=="
      hasMarginRight
    />
    <Icon
      iconName={faLinkedinIn}
      link="https://www.linkedin.com/company/distribuidora-valor-sdvm-s-a/"
    />
  </SocialNetworkContainer>
);
